import { useRubricTableColumns } from 'components/Rubrics/Table';
import { useViewport } from 'contexts/viewport';
import { useTranslation } from 'react-i18next';
import { Button, Drawer, IconButton, ScrollableTableMobileSortFilters, Stack, Text } from 'shell/components';

const FilterDrawer = ({ filters, setFilters, resetFilters, sortState, handleSetSortState }) => {
    const { device } = useViewport();
    const { t } = useTranslation();
    const columns = useRubricTableColumns();

    const onClose = () => {
        setFilters((current) => ({ ...current, open: false }));
    };

    return (
        <Drawer
            anchor={'left'}
            device={device === 'desktop' ? 'tablet' : device}
            offsetForSidebar
            open={filters.open}
            onClose={onClose}
        >
            <Stack spacing={3}>
                <IconButton
                    sx={{ alignSelf: 'flex-end' }}
                    aria-label={'close'}
                    kind={'exit'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClose}
                />
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('controls.sort-by', 'Sort By')}
                    </Text>
                    <Button variant={'borderless'} onClick={resetFilters}>
                        {t('controls.reset-all', 'Reset All')}
                    </Button>
                </Stack>
                <ScrollableTableMobileSortFilters
                    columns={columns}
                    sortState={sortState}
                    handleSetSortState={handleSetSortState}
                />
            </Stack>
        </Drawer>
    );
};

export default FilterDrawer;
